import { defineMessages } from 'react-intl';

export const CalibrationIntl = defineMessages({
  continue: {
    id: 'CalibrationIntl.continue',
    defaultMessage: 'NEXT',
  },
  calibrate: {
    id: 'CalibrationIntl.calibrate',
    defaultMessage: 'CONFIRM',
  },
  back: {
    id: 'CalibrationIntl.back',
    defaultMessage: 'BACK',
  },
  title: {
    id: 'CalibrationIntl.title',
    defaultMessage: 'ADAS Calibration',
  },
  isNotInteger: {
    id: 'CalibrationIntl.isNotInteger',
    defaultMessage: 'Value should be integer',
  },
  selectedImagedRequired: {
    id: 'CalibrationIntl.selectedImagedRequired',
    defaultMessage: 'Please select image',
  },
  cameraHeightRequired: {
    id: 'CalibrationIntl.cameraHeightRequired',
    defaultMessage: 'Camera Height should not be empty',
  },
  cameraHeightNotCorrectValue: {
    id: 'CalibrationIntl.cameraHeightNotCorrectValue',
    defaultMessage: 'Camera Height should be {restriction} ',
  },
  cameraOffsetRequired: {
    id: 'CalibrationIntl.cameraOffsetRequired',
    defaultMessage: 'Camera Offset should not be empty',
  },
  cameraOffsetNotCorrectValue: {
    id: 'CalibrationIntl.cameraOffsetNotCorrectValue',
    defaultMessage: 'Camera Offset should be {restriction}',
  },
  vehicleWidthRequired: {
    id: 'CalibrationIntl.vehicleWidthRequired',
    defaultMessage: 'Vehicle Width should not be empty',
  },
  vehicleWidthCorrectValue: {
    id: 'CalibrationIntl.vehicleWidthCorrectValue',
    defaultMessage: 'Vehicle Width should be {restriction}',
  },
  success: {
    id: 'CalibrationIntl.success',
    defaultMessage: 'Success',
  },
  error: {
    id: 'CalibrationIntl.error',
    defaultMessage: 'Error',
  },
  done: {
    id: 'CalibrationIntl.done',
    defaultMessage: 'Done',
  },
  close: {
    id: 'CalibrationIntl.close',
    defaultMessage: 'Close',
  },
  successMessage: {
    id: 'CalibrationIntl.successMessage',
    defaultMessage: 'Your device has been calibrated successfully',
  },
  errorMessage: {
    id: 'CalibrationIntl.errorMessage',
    defaultMessage:
      'Unfortunately your device is not successfully calibrated, please make sure you follow all the instructions.',
  },
  tryAgain: {
    id: 'CalibrationIntl.tryAgain',
    defaultMessage: 'Try again',
  },
  errorAccessMessage: {
    id: 'CalibrationIntl.errorAccessMessage',
    defaultMessage: 'Access denied for this user',
  },
  errorDeviceMessage: {
    id: 'CalibrationIntl.errorDeviceMessage',
    defaultMessage: 'Device is not online/standby or not supporting this action',
  },
  errorDeviceCalibratedMessage: {
    id: 'CalibrationIntl.errorDeviceCalibratedMessage',
    defaultMessage: 'Device is already calibrated',
  },
  errorGeneralMessage: {
    id: 'CalibrationIntl.errorGeneralMessage',
    defaultMessage: 'Device or User not found',
  },
  errorImageMessage: {
    id: 'CalibrationIntl.errorImageMessage',
    defaultMessage: 'ADAS Calibration Images not found',
  },
});
